const Icons = {
  CollapseAllIcon: (className?: string) => (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.25 16.5L6 11.25L0.75 16.5M0.75 1.5L6 6.75L11.25 1.5"
        stroke="#8C9EA1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  ExpandAllIcon: (className?: string) => (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.75 12L6 17.25L11.25 12M11.25 6L6 0.75L0.75 6"
        stroke="#8C9EA1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  DelegatesTo: (className?: string) => (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.641 1.07L5.46 0.393999C5.88467 1.07867 6.29633 1.67667 6.695 2.188C7.09367 2.69933 7.50533 3.15433 7.93 3.553C8.35467 3.943 8.80967 4.31567 9.295 4.671V4.749C8.80967 5.09567 8.35467 5.46833 7.93 5.867C7.50533 6.26567 7.09367 6.72067 6.695 7.232C6.29633 7.73467 5.88467 8.33267 5.46 9.026L4.641 8.35C4.99633 7.804 5.35167 7.31433 5.707 6.881C6.071 6.439 6.43067 6.05333 6.786 5.724C7.14133 5.39467 7.488 5.126 7.826 4.918C8.164 4.71 8.489 4.567 8.801 4.489V4.931C8.489 4.853 8.164 4.71 7.826 4.502C7.488 4.294 7.14133 4.02533 6.786 3.696C6.43067 3.36667 6.071 2.98533 5.707 2.552C5.35167 2.11 4.99633 1.616 4.641 1.07ZM0.637 4.19H5.252C5.798 4.19 6.27467 4.203 6.682 4.229C7.098 4.255 7.46633 4.28533 7.787 4.32L8.567 4.71L7.787 5.1C7.46633 5.13467 7.098 5.165 6.682 5.191C6.27467 5.217 5.798 5.23 5.252 5.23H0.637V4.19Z"
        fill="#8C9EA1"
      />
    </svg>
  ),

  Invokes: (className?: string) => (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.755 5.817C0.755 2.723 3.251 0.227 6.345 0.227C8.854 0.227 10.96 1.865 11.675 4.127C12.052 3.62 12.624 3.048 13.417 2.424L13.586 3.165C12.754 4.296 12.208 5.388 11.948 6.48L11.584 6.545C10.869 5.713 9.894 4.959 8.672 4.296L8.49 3.568C9.452 3.776 10.232 4.036 10.765 4.322C10.141 2.476 8.399 1.15 6.345 1.15C3.758 1.15 1.678 3.23 1.678 5.817H0.755Z"
        fill="#8C9EA1"
      />
    </svg>
  ),

  CheckCircleOutline: (className?: string) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.6872 7.18709C10.7363 7.14132 10.7757 7.08612 10.8031 7.02479C10.8304 6.96345 10.8451 6.89724 10.8463 6.83011C10.8475 6.76297 10.8351 6.69629 10.81 6.63403C10.7848 6.57177 10.7474 6.51522 10.6999 6.46774C10.6524 6.42026 10.5959 6.38283 10.5336 6.35768C10.4714 6.33253 10.4047 6.32018 10.3375 6.32137C10.2704 6.32255 10.2042 6.33725 10.1429 6.36457C10.0815 6.3919 10.0263 6.4313 9.98055 6.48043L7.00055 9.46043L6.02055 8.48043C5.92577 8.39211 5.8004 8.34403 5.67087 8.34631C5.54133 8.3486 5.41774 8.40107 5.32613 8.49268C5.23453 8.58429 5.18205 8.70788 5.17977 8.83741C5.17748 8.96695 5.22556 9.09231 5.31388 9.18709L6.64722 10.5204C6.74097 10.6141 6.86805 10.6667 7.00055 10.6667C7.13305 10.6667 7.26013 10.6141 7.35388 10.5204L10.6872 7.18709Z"
        fill="#8C9EA1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 1.33301C4.0407 1.33301 0.832031 4.54167 0.832031 8.49967C0.832031 12.4577 4.0407 15.6663 7.9987 15.6663C11.9567 15.6663 15.1654 12.4577 15.1654 8.49967C15.1654 4.54167 11.9567 1.33301 7.9987 1.33301ZM1.83203 8.49967C1.83203 6.86417 2.48173 5.29566 3.63821 4.13918C4.79468 2.98271 6.3632 2.33301 7.9987 2.33301C9.6342 2.33301 11.2027 2.98271 12.3592 4.13918C13.5157 5.29566 14.1654 6.86417 14.1654 8.49967C14.1654 10.1352 13.5157 11.7037 12.3592 12.8602C11.2027 14.0166 9.6342 14.6663 7.9987 14.6663C6.3632 14.6663 4.79468 14.0166 3.63821 12.8602C2.48173 11.7037 1.83203 10.1352 1.83203 8.49967Z"
        fill="#8C9EA1"
      />
    </svg>
  ),

  /** Failure counterpart to CheckCircleOutline; same ring, same muted weight. */
  CrossCircleOutline: (className?: string) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.11 6.61L9.89 10.39M9.89 6.61L6.11 10.39"
        stroke="#8C9EA1"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 1.33301C4.0407 1.33301 0.832031 4.54167 0.832031 8.49967C0.832031 12.4577 4.0407 15.6663 7.9987 15.6663C11.9567 15.6663 15.1654 12.4577 15.1654 8.49967C15.1654 4.54167 11.9567 1.33301 7.9987 1.33301ZM1.83203 8.49967C1.83203 6.86417 2.48173 5.29566 3.63821 4.13918C4.79468 2.98271 6.3632 2.33301 7.9987 2.33301C9.6342 2.33301 11.2027 2.98271 12.3592 4.13918C13.5157 5.29566 14.1654 6.86417 14.1654 8.49967C14.1654 10.1352 13.5157 11.7037 12.3592 12.8602C11.2027 14.0166 9.6342 14.6663 7.9987 14.6663C6.3632 14.6663 4.79468 14.0166 3.63821 12.8602C2.48173 11.7037 1.83203 10.1352 1.83203 8.49967Z"
        fill="#8C9EA1"
      />
    </svg>
  ),

  /**
   * Semantic pass/fail pair for the test-visualization views, where the
   * outcome itself is the information being read. Same ring geometry as
   * CheckCircleOutline/CrossCircleOutline, but colour-coded instead of muted
   * — keep those muted variants for contexts where the icon only decorates a
   * label (eval tooltips, tree-view nodes).
   */
  TestPassIcon: (className?: string) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.6872 7.18709C10.7363 7.14132 10.7757 7.08612 10.8031 7.02479C10.8304 6.96345 10.8451 6.89724 10.8463 6.83011C10.8475 6.76297 10.8351 6.69629 10.81 6.63403C10.7848 6.57177 10.7474 6.51522 10.6999 6.46774C10.6524 6.42026 10.5959 6.38283 10.5336 6.35768C10.4714 6.33253 10.4047 6.32018 10.3375 6.32137C10.2704 6.32255 10.2042 6.33725 10.1429 6.36457C10.0815 6.3919 10.0263 6.4313 9.98055 6.48043L7.00055 9.46043L6.02055 8.48043C5.92577 8.39211 5.8004 8.34403 5.67087 8.34631C5.54133 8.3486 5.41774 8.40107 5.32613 8.49268C5.23453 8.58429 5.18205 8.70788 5.17977 8.83741C5.17748 8.96695 5.22556 9.09231 5.31388 9.18709L6.64722 10.5204C6.74097 10.6141 6.86805 10.6667 7.00055 10.6667C7.13305 10.6667 7.26013 10.6141 7.35388 10.5204L10.6872 7.18709Z"
        fill="#6CF2A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 1.33301C4.0407 1.33301 0.832031 4.54167 0.832031 8.49967C0.832031 12.4577 4.0407 15.6663 7.9987 15.6663C11.9567 15.6663 15.1654 12.4577 15.1654 8.49967C15.1654 4.54167 11.9567 1.33301 7.9987 1.33301ZM1.83203 8.49967C1.83203 6.86417 2.48173 5.29566 3.63821 4.13918C4.79468 2.98271 6.3632 2.33301 7.9987 2.33301C9.6342 2.33301 11.2027 2.98271 12.3592 4.13918C13.5157 5.29566 14.1654 6.86417 14.1654 8.49967C14.1654 10.1352 13.5157 11.7037 12.3592 12.8602C11.2027 14.0166 9.6342 14.6663 7.9987 14.6663C6.3632 14.6663 4.79468 14.0166 3.63821 12.8602C2.48173 11.7037 1.83203 10.1352 1.83203 8.49967Z"
        fill="#6CF2A2"
      />
    </svg>
  ),

  TestFailIcon: (className?: string) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.11 6.61L9.89 10.39M9.89 6.61L6.11 10.39"
        stroke="#F26C74"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 1.33301C4.0407 1.33301 0.832031 4.54167 0.832031 8.49967C0.832031 12.4577 4.0407 15.6663 7.9987 15.6663C11.9567 15.6663 15.1654 12.4577 15.1654 8.49967C15.1654 4.54167 11.9567 1.33301 7.9987 1.33301ZM1.83203 8.49967C1.83203 6.86417 2.48173 5.29566 3.63821 4.13918C4.79468 2.98271 6.3632 2.33301 7.9987 2.33301C9.6342 2.33301 11.2027 2.98271 12.3592 4.13918C13.5157 5.29566 14.1654 6.86417 14.1654 8.49967C14.1654 10.1352 13.5157 11.7037 12.3592 12.8602C11.2027 14.0166 9.6342 14.6663 7.9987 14.6663C6.3632 14.6663 4.79468 14.0166 3.63821 12.8602C2.48173 11.7037 1.83203 10.1352 1.83203 8.49967Z"
        fill="#F26C74"
      />
    </svg>
  ),

  ErrorIcon: (className?: string) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7 0.625C5.73915 0.625 4.50661 0.998887 3.45824 1.69938C2.40988 2.39988 1.59278 3.39551 1.11027 4.56039C0.627762 5.72527 0.501516 7.00707 0.747497 8.2437C0.993478 9.48033 1.60064 10.6162 2.4922 11.5078C3.38376 12.3994 4.51967 13.0065 5.7563 13.2525C6.99293 13.4985 8.27473 13.3722 9.43961 12.8897C10.6045 12.4072 11.6001 11.5901 12.3006 10.5418C13.0011 9.4934 13.375 8.26086 13.375 7C13.373 5.30985 12.7007 3.6895 11.5056 2.49439C10.3105 1.29927 8.69015 0.626985 7 0.625ZM7 12.625C5.88748 12.625 4.79995 12.2951 3.87492 11.677C2.94989 11.0589 2.22892 10.1804 1.80318 9.15259C1.37744 8.12476 1.26604 6.99376 1.48309 5.90262C1.70013 4.81147 2.23586 3.80919 3.02253 3.02252C3.8092 2.23585 4.81148 1.70012 5.90262 1.48308C6.99376 1.26604 8.12476 1.37743 9.1526 1.80318C10.1804 2.22892 11.0589 2.94989 11.677 3.87492C12.2951 4.79994 12.625 5.88748 12.625 7C12.6233 8.49133 12.0302 9.92111 10.9757 10.9756C9.92112 12.0302 8.49134 12.6233 7 12.625ZM6.625 7.5V4C6.625 3.90054 6.66451 3.80516 6.73484 3.73484C6.80516 3.66451 6.90055 3.625 7 3.625C7.09946 3.625 7.19484 3.66451 7.26517 3.73484C7.33549 3.80516 7.375 3.90054 7.375 4V7.5C7.375 7.59946 7.33549 7.69484 7.26517 7.76517C7.19484 7.83549 7.09946 7.875 7 7.875C6.90055 7.875 6.80516 7.83549 6.73484 7.76517C6.66451 7.69484 6.625 7.59946 6.625 7.5ZM7.625 9.75C7.625 9.87361 7.58835 9.99445 7.51967 10.0972C7.451 10.2 7.35338 10.2801 7.23918 10.3274C7.12498 10.3747 6.99931 10.3871 6.87807 10.363C6.75683 10.3389 6.64547 10.2794 6.55806 10.1919C6.47065 10.1045 6.41113 9.99317 6.38701 9.87193C6.3629 9.75069 6.37527 9.62503 6.42258 9.51082C6.46988 9.39662 6.54999 9.29901 6.65277 9.23033C6.75555 9.16166 6.87639 9.125 7 9.125C7.16576 9.125 7.32473 9.19085 7.44195 9.30806C7.55916 9.42527 7.625 9.58424 7.625 9.75Z"
        fill="current"
      />
    </svg>
  ),

  McpIcon: (className?: string) => (
    <svg
      fill="currentColor"
      fillRule="evenodd"
      height="16"
      viewBox="0 0 24 24"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z"
        fill="#ffffff"
      ></path>
      <path
        d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z"
        fill="#ffffff"
      ></path>
    </svg>
  ),

  EvaluateIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.6667 2.66663C12.1167 2.67463 12.902 2.73929 13.414 3.25129C14 3.83729 14 4.77996 14 6.66529V10.6653C14 12.5513 14 13.494 13.414 14.08C12.8287 14.6653 11.8853 14.6653 10 14.6653H6C4.11467 14.6653 3.17133 14.6653 2.586 14.08C2 13.4933 2 12.5513 2 10.6653V6.66529C2 4.77996 2 3.83729 2.586 3.25129C3.098 2.73929 3.88333 2.67463 5.33333 2.66663"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6 8.93331L7.14267 9.99998L10 7.33331"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 2.33331C5.33325 2.0681 5.43861 1.81374 5.62615 1.62621C5.81368 1.43867 6.06804 1.33331 6.33325 1.33331H9.66659C9.9318 1.33331 10.1862 1.43867 10.3737 1.62621C10.5612 1.81374 10.6666 2.0681 10.6666 2.33331V2.99998C10.6666 3.2652 10.5612 3.51955 10.3737 3.70709C10.1862 3.89462 9.9318 3.99998 9.66659 3.99998H6.33325C6.06804 3.99998 5.81368 3.89462 5.62615 3.70709C5.43861 3.51955 5.33325 3.2652 5.33325 2.99998V2.33331Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
  OkahuIcon: (className?: string) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.0596 0.522432C12.9535 1.51235 17.4048 6.7311 17.4048 12.6159C17.4048 16.1376 16.926 18.4049 15.7584 20.4303C14.2625 23.026 12.3606 23.911 12.0596 23.984C11.7586 23.911 9.86128 23.026 8.36078 20.4303C7.19322 18.4049 6.71434 16.1422 6.71434 12.6159C6.71434 6.73567 11.1657 1.51235 12.0596 0.522432ZM12.0596 0.203125C12.0596 0.203125 6.5 5.9419 6.5 12.6113C6.5 16.4341 7.07924 18.6329 8.17383 20.5352C9.78834 23.3316 11.8726 24.1984 12.0596 24.1984C12.2466 24.1984 14.3354 23.3316 15.9499 20.5352C17.0491 18.6329 17.6238 16.4341 17.6238 12.6113C17.6238 5.93734 12.0641 0.203125 12.0641 0.203125H12.0596Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
      <path
        d="M6.94106 13.4125L11.9853 15.3102L12.0629 15.3376L12.1404 15.3102L17.1846 13.4125L12.0629 23.7177L6.94563 13.4125M17.627 13.0156L12.0674 15.1096L6.50781 13.0156L12.0674 24.2058L17.6316 13.0156H17.627Z"
        fill="white"
      />
      <path
        d="M6.94106 13.4125L11.9853 15.3102L12.0629 15.3376L12.1404 15.3102L17.1846 13.4125L12.0629 23.7177L6.94563 13.4125M17.627 13.0156L12.0674 15.1096L6.50781 13.0156L12.0674 24.2058L17.6316 13.0156H17.627Z"
        stroke="white"
        strokeWidth="0.4"
      />
      <path
        d="M8.48661 6.58982L11.9118 9.60975L12.0532 9.7375L12.1945 9.60975L15.6197 6.58982L12.0486 23.1675L8.48205 6.58982M15.9663 5.99219L12.0486 9.44553L8.13086 5.99219L12.0486 24.1985L15.9663 5.99219Z"
        fill="white"
      />
      <path
        d="M8.48661 6.58982L11.9118 9.60975L12.0532 9.7375L12.1945 9.60975L15.6197 6.58982L12.0486 23.1675L8.48205 6.58982M15.9663 5.99219L12.0486 9.44553L8.13086 5.99219L12.0486 24.1985L15.9663 5.99219Z"
        stroke="white"
        strokeWidth="0.4"
      />
      <path
        d="M12.0593 9.777C12.7206 10.5434 15.2381 13.6911 15.2381 17.1307C15.2381 19.2656 14.9508 20.6342 14.2438 21.8567C13.391 23.3348 12.301 23.905 12.0593 23.978C11.8175 23.9005 10.7275 23.3302 9.87463 21.8567C9.16771 20.6342 8.88036 19.2656 8.88036 17.1307C8.88036 13.6956 11.398 10.5434 12.0593 9.777ZM12.0593 9.45312C12.0593 9.45312 8.66602 13.0615 8.66602 17.1353C8.66602 19.4664 9.01719 20.8075 9.68763 21.9708C10.6728 23.6769 11.9452 24.2061 12.0593 24.2061C12.1733 24.2061 13.4503 23.6769 14.4309 21.9708C15.1013 20.8121 15.4525 19.4709 15.4525 17.1353C15.4525 13.0615 12.0593 9.45312 12.0593 9.45312Z"
        fill="white"
      />
      <path
        d="M16.6643 17.6573L12.058 23.8386L7.46065 17.6573L11.985 18.7932L12.0397 18.8069L12.0944 18.7932L16.6643 17.6527M17.2025 17.2969L12.0443 18.5833L6.93164 17.2969L12.0625 24.1989L17.2025 17.2969Z"
        fill="white"
      />
      <path
        d="M12.0589 15.4378C12.5378 16.008 13.9334 17.8465 13.9334 19.84C13.9334 21.1401 13.7601 21.9749 13.3314 22.7139C12.8206 23.5989 12.2094 23.9091 12.0544 23.973C11.9039 23.9091 11.2927 23.5989 10.7819 22.7139C10.3532 21.9749 10.1799 21.1401 10.1799 19.84C10.1799 17.8465 11.5801 16.008 12.0544 15.4378M12.0544 15.1094C12.0544 15.1094 9.96094 17.331 9.96094 19.8446C9.96094 21.2815 10.1799 22.1118 10.5903 22.828C11.1969 23.8818 11.9814 24.2057 12.0498 24.2057C12.1182 24.2057 12.9072 23.8772 13.5138 22.828C13.9288 22.1118 14.1432 21.2861 14.1432 19.8446C14.1432 17.3356 12.0498 15.1094 12.0498 15.1094H12.0544Z"
        fill="white"
      />
      <path
        d="M12.059 18.9235C12.3919 19.3386 13.1307 20.397 13.1307 21.5192C13.1307 22.3038 13.0258 22.8056 12.7704 23.2481C12.4968 23.7226 12.173 23.9141 12.0544 23.9734C11.9358 23.9141 11.6165 23.718 11.3429 23.2481C11.0875 22.8056 10.9826 22.3038 10.9826 21.5192C10.9826 20.397 11.7215 19.3432 12.0544 18.9235M12.0544 18.5859C12.0544 18.5859 10.7637 19.9681 10.7637 21.5146C10.7637 22.3996 10.8959 22.9105 11.1513 23.353C11.5253 24.0008 12.0088 24.2015 12.0498 24.2015C12.0909 24.2015 12.5789 24.0008 12.9529 23.353C13.2083 22.9105 13.3405 22.4042 13.3405 21.5146C13.3405 19.9681 12.0498 18.5859 12.0498 18.5859H12.0544Z"
        fill="white"
      />
      <path
        d="M12.1682 9.44531H11.9492V24.1983H12.1682V9.44531Z"
        fill="white"
      />
    </svg>
  ),
  WrenchIcon: (className?: string) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.91763 7.07518C10.0912 7.25221 10.1884 7.49025 10.1884 7.73818C10.1884 7.98611 10.0912 8.22415 9.91763 8.40118L8.40263 9.91618C8.2256 10.0898 7.98756 10.187 7.73963 10.187C7.49171 10.187 7.25366 10.0898 7.07663 9.91618L4.52863 7.36918C4.03363 6.87518 3.20163 7.03618 3.08263 7.72518C2.92714 8.62693 2.99174 9.5529 3.27093 10.4243C3.55013 11.2958 4.03566 12.0869 4.68623 12.7304C5.3368 13.3739 6.13316 13.8507 7.00759 14.1204C7.88202 14.39 8.80863 14.4445 9.70863 14.2792C10.5286 14.1292 11.4156 14.2572 12.0046 14.8452L17.5706 20.4122C17.7559 20.605 17.9777 20.7589 18.2231 20.8649C18.4685 20.9709 18.7326 21.0268 19 21.0295C19.2673 21.0322 19.5325 20.9815 19.78 20.8804C20.0275 20.7794 20.2523 20.6299 20.4414 20.4409C20.6304 20.2519 20.7798 20.027 20.8809 19.7795C20.982 19.532 21.0327 19.2668 21.03 18.9995C21.0273 18.7322 20.9713 18.4681 20.8653 18.2226C20.7593 17.9772 20.6054 17.7554 20.4126 17.5702L14.8456 12.0042C14.2576 11.4152 14.1296 10.5272 14.2796 9.70818C14.4445 8.80825 14.3897 7.88183 14.1198 7.00763C13.85 6.13343 13.3731 5.33728 12.7298 4.68682C12.0864 4.03637 11.2955 3.55083 10.4243 3.27147C9.55307 2.9921 8.62731 2.92717 7.72563 3.08218C7.03663 3.20218 6.87563 4.03318 7.36963 4.52818L9.91763 7.07518Z"
        stroke="#FFCB78"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ClockCircleLinear: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.48" clip-path="url(#clip0_10423_9991)">
        <path
          d="M8.00004 14.6663C11.6819 14.6663 14.6667 11.6816 14.6667 7.99967C14.6667 4.31778 11.6819 1.33301 8.00004 1.33301C4.31814 1.33301 1.33337 4.31778 1.33337 7.99967C1.33337 11.6816 4.31814 14.6663 8.00004 14.6663Z"
          stroke="#8C9EA1"
          strokeWidth="1.5"
        />
        <path
          d="M8 5.33301V7.99967L9.66667 9.66634"
          stroke="#8C9EA1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10423_9991">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Close: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6668 6.91706L3.41668 2.66699L2 4.08365L6.25012 8.33372L2.00016 12.5836L3.41684 14.0003L7.6668 9.75039L11.9168 14.0003L13.3334 12.5836L9.08348 8.33372L13.3336 4.08366L11.9169 2.667L7.6668 6.91706Z"
        fill="#C1C9CF"
      />
    </svg>
  ),
  CopyIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.666 4.71387C13.7704 4.71387 14.6658 5.60949 14.666 6.71387V12.666C14.666 13.7706 13.7706 14.666 12.666 14.666H6.71387L6.50977 14.6562C5.50111 14.554 4.71387 13.7017 4.71387 12.666V6.71387C4.71408 5.67842 5.50125 4.82687 6.50977 4.72461L6.71387 4.71387H12.666ZM6.71387 6.21387C6.4379 6.21391 6.2141 6.43795 6.21387 6.71387V12.666C6.21387 12.9421 6.43776 13.166 6.71387 13.166H12.666C12.9422 13.166 13.166 12.9422 13.166 12.666V6.71387C13.1658 6.43792 12.942 6.21387 12.666 6.21387H6.71387ZM10.1426 2.75H4C3.30965 2.75 2.75 3.30964 2.75 4V10.1426H1.25V4C1.25 2.48122 2.48122 1.25 4 1.25H10.1426V2.75Z"
        fill="#43B0CD"
      />
    </svg>
  ),
  CopyGreenCheckIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3538 4.85403L6.35375 12.854C6.30731 12.9005 6.25217 12.9374 6.19147 12.9626C6.13077 12.9877 6.06571 13.0007 6 13.0007C5.93429 13.0007 5.86923 12.9877 5.80853 12.9626C5.74783 12.9374 5.69269 12.9005 5.64625 12.854L2.14625 9.35403C2.05243 9.26021 1.99972 9.13296 1.99972 9.00028C1.99972 8.8676 2.05243 8.74035 2.14625 8.64653C2.24007 8.55271 2.36732 8.5 2.5 8.5C2.63268 8.5 2.75993 8.55271 2.85375 8.64653L6 11.7934L13.6462 4.14653C13.7401 4.05271 13.8673 4 14 4C14.1327 4 14.2599 4.05271 14.3538 4.14653C14.4476 4.24035 14.5003 4.3676 14.5003 4.50028C14.5003 4.63296 14.4476 4.76021 14.3538 4.85403Z"
        fill="#6CF2A2"
      />
    </svg>
  ),
  DownArrowIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 2.66732V13.334M8 13.334L4 9.33398M8 13.334L12 9.33398"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  UpArrowIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 13.3327V2.66602M8 2.66602L12 6.66602M8 2.66602L4 6.66602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Search: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : 'stroke-[#C1C9CF]'}
    >
      <g clipPath="url(#clip0_12683_22435)">
        <path
          d="M13 11.1381L14.2811 12.4192C14.7952 12.9332 14.7952 13.7667 14.2811 14.2808C13.767 14.7949 12.9336 14.7949 12.4195 14.2808L11.1384 12.9997M1.33331 6.99967C1.33331 3.87006 3.87037 1.33301 6.99998 1.33301C10.1296 1.33301 12.6666 3.87006 12.6666 6.99967C12.6666 10.1293 10.1296 12.6663 6.99998 12.6663C3.87037 12.6663 1.33331 10.1293 1.33331 6.99967Z"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12683_22435">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  AskKahu: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" className={className}>
      <circle cx="20" cy="20" r="20" fill="#08242F"/>
      <path d="M11.8189 15.8953L12.0798 16.4956C12.1206 16.5934 12.1893 16.6769 12.2775 16.7356C12.3656 16.7944 12.4692 16.8257 12.5751 16.8257C12.681 16.8257 12.7846 16.7944 12.8727 16.7356C12.9608 16.6769 13.0296 16.5934 13.0704 16.4956L13.3313 15.8953C13.7901 14.8333 14.6302 13.9819 15.6859 13.5089L16.491 13.1493C16.5886 13.1044 16.6714 13.0324 16.7294 12.9419C16.7873 12.8514 16.8182 12.7462 16.8182 12.6387C16.8182 12.5312 16.7873 12.4259 16.7294 12.3354C16.6714 12.2449 16.5886 12.1729 16.491 12.128L15.7305 11.7896C14.6482 11.3032 13.7937 10.4202 13.343 9.32258L13.0747 8.67453C13.0352 8.57415 12.9665 8.48797 12.8774 8.42722C12.7883 8.36647 12.6829 8.33398 12.5751 8.33398C12.4673 8.33398 12.3619 8.36647 12.2728 8.42722C12.1837 8.48797 12.115 8.57415 12.0755 8.67453L11.8072 9.32152C11.357 10.4194 10.5028 11.3027 9.42077 11.7896L8.65924 12.129C8.56187 12.1741 8.47943 12.2461 8.42165 12.3365C8.36387 12.4268 8.33317 12.5319 8.33317 12.6392C8.33317 12.7465 8.36387 12.8515 8.42165 12.9419C8.47943 13.0323 8.56187 13.1043 8.65924 13.1493L9.46532 13.5078C10.5208 13.9813 11.3606 14.8331 11.8189 15.8953ZM23.1814 10.4564H18.9389V12.5777H23.1814C24.8692 12.5777 26.4879 13.2481 27.6813 14.4416C28.8748 15.635 29.5452 17.2537 29.5452 18.9415C29.5452 22.7704 26.934 25.2692 21.0602 27.9356V25.3053H18.9389C17.2511 25.3053 15.6325 24.6348 14.439 23.4414C13.2456 22.2479 12.5751 20.6293 12.5751 18.9415H10.4538C10.4538 21.1918 11.3478 23.3501 12.939 24.9413C14.5303 26.5326 16.6885 27.4265 18.9389 27.4265V31.1388C24.2421 29.0175 31.6665 25.8356 31.6665 18.9415C31.6665 16.6911 30.7725 14.5329 29.1813 12.9416C27.59 11.3504 25.4318 10.4564 23.1814 10.4564Z" fill="#34BCAF"/>
    </svg>
  ),
  LikeFeedbackIcon: (className?: string) => (
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
    <path d="M8.00684 1.83398H9.08008C9.33724 1.83406 9.5817 1.95634 9.74316 2.16699H8.0791L7.92871 2.34668L4.94922 5.9209L4.83301 6.05957V13.167H11.8867L12.0078 12.8428L13.6797 8.38086H13.8398V6.16699H8.67871C8.65156 6.16669 8.62468 6.15998 8.60059 6.14746C8.57672 6.13501 8.55581 6.11751 8.54004 6.0957C8.52417 6.07366 8.51398 6.04734 8.50977 6.02051C8.50586 5.99532 8.50748 5.96974 8.51465 5.94531L9.55371 2.8252L9.76367 2.19434C9.90748 2.40747 9.94663 2.67953 9.86523 2.92969L9.11914 5.17676L8.90039 5.83398H13.3398C13.7969 5.83398 14.1727 6.20995 14.1729 6.66699V8.00098C14.1728 8.02654 14.1675 8.0486 14.1621 8.06348L12.3252 12.958V12.959C12.2658 13.1178 12.1588 13.2548 12.0195 13.3516C11.8804 13.4482 11.7153 13.5006 11.5459 13.501H2.67285C2.21581 13.5008 1.83984 13.1241 1.83984 12.667V6.66699C1.84002 6.21006 2.21592 5.83416 2.67285 5.83398H4.59375L4.74414 5.6543L7.87695 1.89453L7.90332 1.86816C7.93103 1.84643 7.96654 1.83398 8.00684 1.83398ZM2.16699 13.167H4.5V6.16699H2.16699V13.167Z" fill="#C1C9CF" stroke="#EBEFF1"/>
  </svg>
  ),
  LikeFeedbackFilledIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M2.66634 14.0007H3.33301V5.33398H2.66634C1.93301 5.33398 1.33301 5.93398 1.33301 6.66732V12.6673C1.33301 13.4007 1.93301 14.0007 2.66634 14.0007ZM13.333 5.33398H8.92634L9.67301 3.08732C9.80634 2.68065 9.73967 2.23398 9.49301 1.88732C9.23967 1.54065 8.83967 1.33398 8.41301 1.33398H8.00634C7.80634 1.33398 7.61967 1.42065 7.49301 1.57398L4.67301 4.96065V14.0007H11.5463C11.8176 14.0002 12.0823 13.917 12.3051 13.7621C12.5278 13.6072 12.6981 13.3881 12.793 13.134L14.633 8.23398C14.6597 8.16065 14.673 8.08065 14.673 8.00065V6.66732C14.673 5.93398 14.073 5.33398 13.3397 5.33398H13.333Z" fill="#C1C9CF"/>
    </svg>
  ),
  DislikeFeedbackIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M13.333 2H4.45967C4.18838 2.00047 3.92369 2.0837 3.70093 2.23855C3.47818 2.39341 3.30796 2.61253 3.21301 2.86667L1.37301 7.76667C1.34634 7.84 1.33301 7.92 1.33301 8V9.33333C1.33301 10.0667 1.93301 10.6667 2.66634 10.6667H6.40634L5.65967 12.9133C5.52634 13.32 5.59301 13.7667 5.83967 14.1133C6.09301 14.46 6.49301 14.6667 6.91967 14.6667H7.99301C8.19301 14.6667 8.37967 14.58 8.50634 14.4267L11.6397 10.6667H13.3263C14.0597 10.6667 14.6597 10.0667 14.6597 9.33333V3.33333C14.6597 2.6 14.0597 2 13.3263 2H13.333ZM10.6663 9.76L7.68634 13.3333H6.91967L7.95967 10.2133C7.99206 10.1129 8.0004 10.0063 7.98402 9.90208C7.96764 9.79785 7.927 9.69894 7.86537 9.6133C7.80374 9.52767 7.72285 9.45772 7.62922 9.40909C7.53559 9.36045 7.43184 9.33451 7.32634 9.33333H2.65967V8.12L4.45301 3.33333H10.6597V9.76H10.6663ZM13.333 9.33333H11.9997V3.33333H13.333V9.33333Z" fill="#C1C9CF"/>
    </svg>
  ),
  DislikeFeedbackFilledIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M13.334 2H12.6673V10.6667H13.334C14.0673 10.6667 14.6673 10.0667 14.6673 9.33333V3.33333C14.6673 2.6 14.0673 2 13.334 2ZM3.21398 2.86667L1.37398 7.76667C1.34732 7.84 1.33398 7.92 1.33398 8V9.33333C1.33398 10.0667 1.93398 10.6667 2.66732 10.6667H7.07398L6.32732 12.9133C6.19398 13.32 6.26065 13.7667 6.50732 14.1133C6.76065 14.46 7.16065 14.6667 7.58732 14.6667H7.99398C8.19398 14.6667 8.38065 14.58 8.50732 14.4267L11.3273 11.04V2H4.46065C4.18936 2.00047 3.92466 2.0837 3.70191 2.23855C3.47915 2.39341 3.30894 2.61253 3.21398 2.86667Z" fill="#C1C9CF"/>
    </svg>
  ),
  UserApprovedIcon : (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M10 12.666C10 11.1927 8.20933 9.99935 6 9.99935C3.79067 9.99935 2 11.1927 2 12.666M14 6.66602L11.3333 9.33268L10 7.99935M6 7.99935C5.29276 7.99935 4.61448 7.7184 4.11438 7.2183C3.61428 6.7182 3.33333 6.03993 3.33333 5.33268C3.33333 4.62544 3.61428 3.94716 4.11438 3.44706C4.61448 2.94697 5.29276 2.66602 6 2.66602C6.70724 2.66602 7.38552 2.94697 7.88562 3.44706C8.38572 3.94716 8.66667 4.62544 8.66667 5.33268C8.66667 6.03993 8.38572 6.7182 7.88562 7.2183C7.38552 7.7184 6.70724 7.99935 6 7.99935Z" stroke="#8C9EA1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  UserFeedbackIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M10 12.666C10 11.1927 8.20933 9.99935 6 9.99935C3.79067 9.99935 2 11.1927 2 12.666M6 7.99935C5.29276 7.99935 4.61448 7.7184 4.11438 7.2183C3.61428 6.7182 3.33333 6.03993 3.33333 5.33268C3.33333 4.62544 3.61428 3.94716 4.11438 3.44706C4.61448 2.94697 5.29276 2.66602 6 2.66602C6.70724 2.66602 7.38552 2.94697 7.88562 3.44706C8.38572 3.94716 8.66667 4.62544 8.66667 5.33268C8.66667 6.03993 8.38572 6.7182 7.88562 7.2183C7.38552 7.7184 6.70724 7.99935 6 7.99935Z" stroke="#8C9EA1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3991 5.27389L13.8144 5.68922C13.9473 5.82211 14.0219 6.00232 14.0219 6.19022C14.0219 6.37812 13.9473 6.55833 13.8144 6.69122L11.9591 8.46467C11.6619 8.76113 11.2839 8.96335 10.8724 9.046L9.73242 9.274L9.96042 8.134C10.0432 7.72272 10.2454 7.34497 10.5418 7.048L12.3971 5.27389C12.53 5.14105 12.7102 5.06642 12.8981 5.06642C13.086 5.06642 13.2662 5.14105 13.3991 5.27389Z" stroke="#8C9EA1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  UserAddedIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M10 12.666C10 11.1927 8.20933 9.99935 6 9.99935C3.79067 9.99935 2 11.1927 2 12.666M12.6667 10.666V8.66602M12.6667 8.66602V6.66602M12.6667 8.66602H10.6667M12.6667 8.66602H14.6667M6 7.99935C5.29276 7.99935 4.61448 7.7184 4.11438 7.2183C3.61428 6.7182 3.33333 6.03993 3.33333 5.33268C3.33333 4.62544 3.61428 3.94716 4.11438 3.44706C4.61448 2.94697 5.29276 2.66602 6 2.66602C6.70724 2.66602 7.38552 2.94697 7.88562 3.44706C8.38572 3.94716 8.66667 4.62544 8.66667 5.33268C8.66667 6.03993 8.38572 6.7182 7.88562 7.2183C7.38552 7.7184 6.70724 7.99935 6 7.99935Z" stroke="#8C9EA1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  ArrowRightIcon: (className?: string) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
        fill="currentColor"
      />
    </svg>
  ),
  ChevronDownIcon: (className?: string) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 13.0942L15.0084 8.08591L13.8309 6.90674L10 10.7401L6.17003 6.90674L4.9917 8.08507L10 13.0942Z"
        fill="currentColor"
      />
    </svg>
  ),
  /** Chevron counterpart to ChevronDownIcon — a disclosure affordance, not the
   *  directional ArrowRightIcon. Inherits colour from the surrounding text. */
  ChevronRightIcon: (className?: string) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6 3.3335L10 8.00016L6 12.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PlusIcon: (className?:string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
      <path d="M10.2959 1.57538V7.93934H16.6599V10.0607H10.2959V16.4246H8.17462V10.0607H1.81066V7.93934H8.17462V1.57538H10.2959Z" fill="#257C9D"/>
    </svg>
  ),
  UserFeedbackAddIcon: (className?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M10 12.666C10 11.1927 8.20933 9.99935 6 9.99935C3.79067 9.99935 2 11.1927 2 12.666M12.6667 10.666V8.66602M12.6667 8.66602V6.66602M12.6667 8.66602H10.6667M12.6667 8.66602H14.6667M6 7.99935C5.29276 7.99935 4.61448 7.7184 4.11438 7.2183C3.61428 6.7182 3.33333 6.03993 3.33333 5.33268C3.33333 4.62544 3.61428 3.94716 4.11438 3.44706C4.61448 2.94697 5.29276 2.66602 6 2.66602C6.70724 2.66602 7.38552 2.94697 7.88562 3.44706C8.38572 3.94716 8.66667 4.62544 8.66667 5.33268C8.66667 6.03993 8.38572 6.7182 7.88562 7.2183C7.38552 7.7184 6.70724 7.99935 6 7.99935Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Plus: (className?: string) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.26586 7.55713L1.60882 7.55719L1.6088 9.44279L7.26584 9.44273L7.26578 15.0995L9.15135 15.0995L9.15142 9.44271L14.8079 9.44265L14.8079 7.55705L9.15144 7.55711L9.1515 1.90029L7.26592 1.90031L7.26586 7.55713Z"
        fill="currentColor"
      />
    </svg>
  ),
  TrashIcon: (className?: string) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      className={className}
    >
      <path
        d="M3 7V17C3 19.2091 4.79086 21 7 21H13C15.2091 21 17 19.2091 17 17V7M12 10V16M8 10L8 16M14 4L12.5937 1.8906C12.2228 1.3342 11.5983 1 10.9296 1H9.07037C8.40166 1 7.7772 1.3342 7.40627 1.8906L6 4M14 4H6M14 4H19M6 4H1"
        stroke="#257C9D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ClipBoardIcon: (className?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M4.842 2.17398C4.88148 1.80599 5.05561 1.46559 5.3309 1.21823C5.6062 0.970863 5.96323 0.834011 6.33333 0.833984H9.66667C10.0368 0.834011 10.3938 0.970863 10.6691 1.21823C10.9444 1.46559 11.1185 1.80599 11.158 2.17398C11.6673 2.18465 12.1067 2.21065 12.4827 2.27998C12.988 2.37332 13.418 2.54932 13.768 2.89998C14.1693 3.30065 14.3413 3.80665 14.4227 4.40665C14.5 4.98398 14.5 5.71932 14.5 6.63065V10.704C14.5 11.6153 14.5 12.3507 14.4227 12.9287C14.3413 13.5287 14.1693 14.034 13.768 14.4353C13.3667 14.8367 12.8613 15.0087 12.2613 15.09C11.6833 15.1673 10.948 15.1673 10.0367 15.1673H5.96333C5.052 15.1673 4.31667 15.1673 3.73867 15.09C3.13867 15.0087 2.63333 14.8367 2.232 14.4353C1.83067 14.034 1.65867 13.5287 1.578 12.9287C1.5 12.3507 1.5 11.6153 1.5 10.704V6.63065C1.5 5.71932 1.5 4.98398 1.578 4.40598C1.658 3.80598 1.83133 3.30065 2.232 2.89932C2.582 2.54932 3.012 2.37265 3.51733 2.27998C3.89333 2.21065 4.33333 2.18465 4.842 2.17398ZM5.83333 2.66798V3.00065C5.83333 3.27665 6.05733 3.50065 6.33333 3.50065H9.66667C9.79928 3.50065 9.92645 3.44797 10.0202 3.3542C10.114 3.26044 10.1667 3.13326 10.1667 3.00065V2.33398C10.1667 2.20138 10.114 2.0742 10.0202 1.98043C9.92645 1.88666 9.79928 1.83398 9.66667 1.83398H6.33333C6.20073 1.83398 6.07355 1.88666 5.97978 1.98043C5.88601 2.0742 5.83333 2.20138 5.83333 2.33398V2.66798ZM11.1567 3.17465C11.114 3.53988 10.9387 3.87673 10.664 4.12118C10.3893 4.36564 10.0344 4.50068 9.66667 4.50065H6.33333C5.96552 4.50066 5.61051 4.36553 5.33581 4.12093C5.0611 3.87634 4.88584 3.53934 4.84333 3.17398C4.36467 3.18465 3.99533 3.20865 3.698 3.26332C3.32067 3.33265 3.10133 3.44465 2.93933 3.60665C2.75467 3.79132 2.63467 4.04998 2.56867 4.53998C2.50133 5.04265 2.5 5.71065 2.5 6.66732V10.6673C2.5 11.624 2.50133 12.2913 2.56867 12.7953C2.63467 13.2846 2.75533 13.5433 2.93933 13.728C3.124 13.9127 3.38267 14.0326 3.87267 14.0986C4.37533 14.166 5.04333 14.1673 6 14.1673H10C10.9567 14.1673 11.624 14.166 12.128 14.0986C12.6173 14.0326 12.876 13.912 13.0607 13.728C13.2453 13.5433 13.3653 13.2846 13.4313 12.7947C13.4987 12.2913 13.5 11.624 13.5 10.6673V6.66732C13.5 5.71065 13.4987 5.04265 13.4313 4.53932C13.3653 4.04998 13.2447 3.79132 13.0607 3.60665C12.898 3.44465 12.6793 3.33332 12.302 3.26332C12.0047 3.20865 11.6353 3.18465 11.1567 3.17465ZM4.16667 9.66732C4.16667 9.53471 4.21935 9.40753 4.31311 9.31376C4.40688 9.22 4.53406 9.16732 4.66667 9.16732H10C10.1326 9.16732 10.2598 9.22 10.3536 9.31376C10.4473 9.40753 10.5 9.53471 10.5 9.66732C10.5 9.79993 10.4473 9.9271 10.3536 10.0209C10.2598 10.1146 10.1326 10.1673 10 10.1673H4.66667C4.53406 10.1673 4.40688 10.1146 4.31311 10.0209C4.21935 9.9271 4.16667 9.79993 4.16667 9.66732ZM4.16667 12.0007C4.16667 11.868 4.21935 11.7409 4.31311 11.6471C4.40688 11.5533 4.53406 11.5007 4.66667 11.5007H8.33333C8.46594 11.5007 8.59312 11.5533 8.68689 11.6471C8.78065 11.7409 8.83333 11.868 8.83333 12.0007C8.83333 12.1333 8.78065 12.2604 8.68689 12.3542C8.59312 12.448 8.46594 12.5007 8.33333 12.5007H4.66667C4.53406 12.5007 4.40688 12.448 4.31311 12.3542C4.21935 12.2604 4.16667 12.1333 4.16667 12.0007Z" fill-rule="evenodd" clip-rule="evenodd" fill="#C1C9CF"/>
    </svg>
  )
};

export default Icons;
